var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import Model from 'models/Model';
import DiagnoseDetail from './DiagnoseDetail';
var Diagnose = /** @class */ (function (_super) {
    __extends(Diagnose, _super);
    function Diagnose() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Diagnose.prototype.getId = function () {
        return Number(this.id);
    };
    Diagnose.prototype.getDetails = function () {
        var raw = this.object;
        if (raw == null) {
            return new DiagnoseDetail();
        }
        if (typeof raw === 'string') {
            try {
                var parsed = JSON.parse(raw);
                if (parsed && typeof parsed === 'object') {
                    return plainToClass(DiagnoseDetail, parsed);
                }
            }
            catch (_a) {
                // Production / factory rows may store a bare string — treat as free text.
            }
            var detail = new DiagnoseDetail();
            detail.setDiagnoseText(raw);
            return detail;
        }
        return plainToClass(DiagnoseDetail, raw);
    };
    Diagnose.prototype.setDetails = function (details) {
        // Persist only string JSONB keys (backend Mutations + legacy `text` required).
        this.object = plainToClass(DiagnoseDetail, details.toPersistableObject());
    };
    Diagnose.prototype.getPatientId = function () {
        return Number(this.patient_id);
    };
    Diagnose.prototype.setPatientId = function (patientId) {
        this.patient_id = patientId;
    };
    Diagnose.prototype.getAppointmentId = function () {
        return Number(this.appointment_id);
    };
    Diagnose.prototype.setAppointmentId = function (appointmentId) {
        this.appointment_id = appointmentId;
    };
    Diagnose.prototype.getCreatedAt = function () {
        if (!this.created_at)
            return '';
        return this.dateFormatter(new Date(this.created_at), 'D MMM YYYY, hh:mm A');
    };
    return Diagnose;
}(Model));
export default Diagnose;
